import FusePageCarded from "@fuse/core/FusePageCarded";
import React, { useEffect, useState, useMemo } from "react";
import ListPageHeader from "../utilities/ListPageHeader";
import { Card, Grid, Typography, Box, CircularProgress, useTheme, alpha } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import jwtDecode from 'jwt-decode';
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";


const getCardColors = (accent, mode) => ({
  cardBg: alpha(accent, mode === "dark" ? 0.16 : 0.06),
  iconBg: alpha(accent, mode === "dark" ? 0.32 : 0.14),
});

export default function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const [cardData, setCardData] = useState({
    bookingReq: 0,
    pendingReqToBookInContainers: 0,
    customerConfirmation: 0,
    amendmentReq: 0,
    newOrder: 0,
    newAb: 0,
    pendingAb: 0,
    revisedAb: 0,
    AbsWithOrder: 0,
    nullOrderNoAB: 0,
  });

  const [unConfirmedOrder, setUnConfirmedOrder] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
    const [name,setName] = useState("")
  useEffect(() => {
    let isMounted = true;

    const fetchAllData = async () => {
      setIsLoading(true);
      const dashboardUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.dashboardCount}`;
      const diffCountUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}api/diffOrderCount`;

      try {
        const [dashboardResult, unconfirmedResult] = await Promise.all([
          OAuthService.getList(dashboardUrl),
          OAuthService.getList(diffCountUrl),
        ]);

        if (isMounted) {
          setCardData(dashboardResult.data);
          setUnConfirmedOrder(unconfirmedResult.data?.unConfirmed || 0);
        }
      } catch (e) {
        console.error("Error fetching dashboard data:", e);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchAllData();

    return () => {
      isMounted = false;
    };
  }, []);
   useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = jwtDecode(localStorage.getItem('token'));
      setName(token.name);
     
    }
  }, [])

  const todayLabel = useMemo(() => {
    const d = new Date();
    const datePart = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(d);
    const weekday = new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(d);
    return `${datePart}, ${weekday}`;
  }, []);


  const menuItems = [
    {
      label: "New Orders from Customer",
      value: cardData.newOrder,
      icon: ShoppingCartOutlinedIcon,
      accent: "#4C6FFF",
      onClick: () => navigate("/order/new-order-list"),
    },
    {
      label: "New ABs from Germany",
      value: cardData.newAb,
      icon: DescriptionOutlinedIcon,
      accent: "#22B07D",
      onClick: () => navigate("/order/new-abs-list"),
    },
    {
      label: "Amendment Requests from Customer",
      value: cardData.amendmentReq,
      icon: EditOutlinedIcon,
      accent: "#F5921B",
      onClick: () => navigate("/order/amendment-request-list"),
    },
    {
      label: "Revised ABs from Germany",
      value: cardData.revisedAb,
      icon: AssignmentTurnedInOutlinedIcon,
      accent: "#8B5CF6",
      onClick: () => navigate("/order/revised-abs-list"),
    },
    {
      label: "AB Confirmations from Customer",
      value: cardData.customerConfirmation,
      icon: VerifiedOutlinedIcon,
      accent: "#2C9FE0",
      onClick: () => navigate("/order/customer-conf-list"),
    },
    {
      label: "Booking Requests from Customer",
      value: cardData.bookingReq,
      icon: EventOutlinedIcon,
      accent: "#F14B6B",
      onClick: () => {
        sessionStorage.setItem("pathName", location.pathname);
        navigate("/container-list");
      },
    },
    {
      label: "Pending orders to book in containers",
      value: cardData.pendingReqToBookInContainers,
      icon: AccountBalanceOutlinedIcon,
      accent: "#16A79A",
      onClick: () => navigate("/order/order-container-list"),
    },
    {
      label: "Pending ABs from Germany",
      value: cardData.pendingAb,
      icon: HourglassEmptyOutlinedIcon,
      accent: "#4C6FFF",
      onClick: () => navigate("/order/pending-abs-list"),
    },
    {
      label: "ABs without Order",
      value: cardData.nullOrderNoAB,
      icon: NoteAltOutlinedIcon,
      accent: "#8B5CF6",
      onClick: () => navigate("/order/abs-without-order"),
    },
    {
      label: "Unconfirmed Orders",
      value: unConfirmedOrder,
      icon: Inventory2OutlinedIcon,
      accent: "#F5921B",
      onClick: () => navigate("/order/unconfirmed-order"),
    },
  ];

  return (
    <FusePageCarded
      classes={{
        content: "flex flex-col",
        header: "h-auto min-h-72 sm:min-h-136",
      }}
      header={
        <ListPageHeader
          componentName="Dashboard"
          pageName="Dashboard"
          showPaginationDropdown={false}
        />
      }
      content={
        <Box className="flex-auto p-16 sm:p-24 w-full">
          {isLoading ? (
            <div className="flex items-center justify-center h-full min-h-[300px]">
              <CircularProgress color="secondary" />
            </div>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 2,
                  mb: 3,
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: 26, fontWeight: 700 }}>
                    Welcome Back, {name}! 👋
                  </Typography>
                  <Typography sx={{ fontSize: 15, color: "text.secondary", mt: 0.5 }}>
                    Here&apos;s an overview of your key activities and requests.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    py: 1,
                    borderRadius: 3,
                    bgcolor: "background.paper",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  }}
                >
                  <CalendarMonthOutlinedIcon sx={{ fontSize: 20, color: "text.secondary" }} />
                  <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{todayLabel}</Typography>
                </Box>
              </Box>

              <Grid container spacing={3}>
                {menuItems.map((item, index) => {
                  const Icon = item.icon;
                  const { cardBg, iconBg } = getCardColors(item.accent, theme.palette.mode);
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                      <Card
                        onClick={item.onClick}
                        elevation={0}
                        sx={{
                          position: "relative",
                          overflow: "hidden",
                          height: 190,
                          p: 2.5,
                          borderRadius: 3,
                          cursor: "pointer",
                          bgcolor: cardBg,
                          borderLeft: `4px solid ${item.accent}`,
                          boxShadow: "0 1px 4px rgba(16,24,40,0.06)",
                          transition: "transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 6px 16px rgba(16,24,40,0.1)",
                          },
                        }}
                      >
                        <Icon
                          sx={{
                            position: "absolute",
                            right: -10,
                            bottom: -10,
                            fontSize: 96,
                            color: item.accent,
                            opacity: 0.08,
                          }}
                        />

                        <Box
                          sx={{
                            width: 44,
                            height: 44,
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: iconBg,
                            mb: 2,
                          }}
                        >
                          <Icon sx={{ fontSize: 22, color: item.accent }} />
                        </Box>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: "text.secondary",
                            lineHeight: 1.3,
                            mb: 1.5,
                            minHeight: 36,
                          }}
                        >
                          {item.label}
                        </Typography>

                        <Typography sx={{ fontSize: 28, fontWeight: 700 }}>
                          {item.value}
                        </Typography>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </>
          )}
        </Box>
      }
      innerScroll
    />
  );
}